<template>
  <div :class="{ 'has-logo': showLogo }">
    <Logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <SidebarItem
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: {
    SidebarItem,
    Logo,
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path, params } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      // подсвечивать родительский пункт меню
      if (meta.activeMenuParent) {
        const arr = path.split("/");

        // если два параметра, убираем 4 последние .../goods/1/edit/2
        if (Object.keys(params).length === 2) {
          return arr.slice(0, -4).join("/");
          // если id, убираем 2 последние .../edit/2
        } else if (params.id) {
          return arr.slice(0, -2).join("/");
          // если не id, убираем 3 последние .../goods/2/list, .../goods/2/create
        } else if (Object.keys(params).length === 1) {
          return arr.slice(0, -3).join("/");
        }
        return arr.slice(0, -1).join("/");
      }

      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  mounted() {
    this.$store.dispatch("permission/generateRoutes", "admin");
  },
};
</script>
